import React from 'react';
import "./Styles/VerifyEmail.css";
//import NavBar from '../NavBar';
//import Footer from '../Footer';
import VerifyEmail from './Components/VerifyEmailRoute/VerifyEmail';
//import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import UserInfoProvider from './Components/Context/UserInfoContext';
import MedicalContextProvider from './Components/Context/MedicalContext';

function VerifyEmailRoute() {
    return (
        <UserInfoProvider>
            <MedicalContextProvider>
                <div className="VerifyEmailRoutePage">
                    <VerifyEmail/>
                </div>
            </MedicalContextProvider>
       </UserInfoProvider>
    );
}

export default VerifyEmailRoute;